import React from 'react';

import { IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { ellipsisHorizontal, statsChart } from 'ionicons/icons';

import Button from 'components/Button';
import ErrorContent from 'components/ErrorContent';
import ProgressBar from 'components/ProgressBar';

const ChartError = ({
  isRefetching,
  error,
  onShowMetricsModal,
}: {
  isRefetching: boolean;
  error: string;
  onShowMetricsModal: () => void;
}) => {
  return (
    <IonGrid>
      <IonRow>
        <IonCol>
          <div className={'chips'}>
            <Button fill={'clear'} onClick={onShowMetricsModal}>
              <IonIcon icon={ellipsisHorizontal} />
            </Button>
          </div>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol className={'ion-padding'}>
          <ErrorContent icon={statsChart} error={error}>
            {isRefetching && <ProgressBar type={'indeterminate'} />}
          </ErrorContent>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
export default ChartError;
